__webpack_require__.p = "/Magic-Cards-2D/";